module.exports = __webpack_public_path__ + "img/cloundl.33498f9d.png";